import { render, staticRenderFns } from "./ObsoleteSelector.vue?vue&type=template&id=6bf6cba4&scoped=true"
import script from "./ObsoleteSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObsoleteSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ObsoleteSelector.vue?vue&type=style&index=0&id=6bf6cba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf6cba4",
  null
  
)

export default component.exports